
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"90","height":"86","viewBox":"0 0 90 86","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.923 33.796c1.272-1.176 2.184-1.968 2.736-2.376.552-.432 1.02-.648 1.404-.648.36 0 .756.18 1.188.54.48.384.72.9.72 1.548 0 .432-.228.924-.684 1.476-.432.528-1.62 1.752-3.564 3.672-2.856 2.808-4.284 4.356-4.284 4.644 0 .24.468 1.068 1.404 2.484a53.79 53.79 0 002.628 3.672c.768.936 1.152 1.668 1.152 2.196 0 .408-.18.828-.54 1.26-.36.48-.888.72-1.584.72-.504 0-.984-.168-1.44-.504-.408-.288-1.32-1.44-2.736-3.456-1.368-1.944-2.1-2.916-2.196-2.916-.12 0-.312.216-.576.648-.264.408-.396.708-.396.9 0 .312-.192.66-.576 1.044-.456.456-.984.684-1.584.684-.456 0-.864-.144-1.224-.432-.36-.288-.588-.684-.684-1.188a.276.276 0 00-.036-.108v-.108c0-.528.24-1.284.72-2.268.504-1.008 1.068-1.884 1.692-2.628.36-.48.54-.852.54-1.116 0-.432-.576-1.812-1.728-4.14-.888-1.68-1.332-2.784-1.332-3.312 0-.408.228-.84.684-1.296.48-.456.924-.684 1.332-.684.552 0 1.068.264 1.548.792s1.032 1.416 1.656 2.664c.744 1.536 1.296 2.304 1.656 2.304.168 0 .348-.168.54-.504.144-.264 1.332-1.452 3.564-3.564z"}})])
          )
        }
      }
    